var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialWorkCaregiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.52,154.28s-2.21,5.89,5.15,9.58c0,0,4.42,2.21,11-5.16l14.72-14.52m38.29-37.75,10.3-28,13.26-11.78M58.64,150.61s-3,4.41,3.68,8.83c0,0,5.89,5.16,14.12-4.15l25.76-25M80,106.43,44.65,141.77s-7.36,7.36-1.47,13.25c0,0,5.15,6.63,15.46-4.41L91,118.21M121.22,81.4S105,88.76,91,73.29l-48.6,48.6s-8.1,7.37-.74,13.25c0,0,3.69,3,8.85,0m89.82-97.79L127.12,50.6,83.67,58.7,52,89.63s7.36,8.83,15.46,5.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.47,104.07s-1.46-3.33-6-1.89c0,0-2.41,0-2.5,6.6l-.92,43.09,7,15.77-.75,10.24m12.89-80.31s-.57-3-5.1-2.17c0,0-4.52.23-4.18,7.41l-.6,20.8m18.84.92.41-28.93s.09-6-4.73-6.09c0,0-4.82-.67-4.64,8.06l-.37,26.53M147,142.75l.57-39.79s1.29-6.61-5-5.8c0,0-2.11.43-3.67,3.57M141,177.57l.15-10.86,14.76-20.89.66-25.61s-6.62-.69-8.79,3.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialWorkCaregiver);
export default __webpack_public_path__ + "static/media/SOCIAL_WORK_CAREGIVER.511c4e1327b30f5a167b131c86f9b7d1.svg";
export { ForwardRef as ReactComponent };